import { Component, OnInit } from '@angular/core';
import { UsersService } from '../../../service/component_dependent/users/users.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-users-list',
  templateUrl: './users-list.component.html',
  styleUrls: ['./users-list.component.scss']
})
export class UsersListComponent implements OnInit {

  protected maxItemsPerPage: number;
  protected page: number;
  protected total: number;

  protected keyword: string;

  protected users = [];

  protected loading: boolean;

  constructor(private usersService: UsersService) {
    this.initializeComponents();
  }

  ngOnInit() {
    this.getUsers(this.maxItemsPerPage, this.page, this.keyword);
  }

  protected getUsers(maxItemsPerPage: number, page: number, keyword: string) {
    this.loading = true;
    this.usersService.getUsers(maxItemsPerPage, page, keyword).subscribe(
      (data: any) => {
        this.loading = false;
        this.reassignVariables(data);
      }
    )
  }

  protected getStatus(status: number): string {
    return status == 1 ? "Active" : "Inactive";
  }

  private reassignVariables(data: any) {
    this.users = data.data.data;
    this.total = data.data.total;
  }

  private initializeComponents() {
    this.maxItemsPerPage = 5;
    this.page = 1;
    this.keyword = '';
  }



}
